import { render, staticRenderFns } from "./riwayatJabatanLainnya.vue?vue&type=template&id=20cf7350&scoped=true&"
import script from "./riwayatJabatanLainnya.vue?vue&type=script&lang=js&"
export * from "./riwayatJabatanLainnya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf7350",
  null
  
)

export default component.exports